import * as yup from 'yup';

function formName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_FORMNAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Form Name is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_FORMNAME_FIELD_MAX_CHARS_32',
        defaultMessage: 'Form Name should be less than 32 chars',
      }),
    );
}

function checkOrder(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_CHECKORDER_FIELD_IS_REQUIRED',
        defaultMessage: 'Check Order is required',
      }),
    )
    .max(
      3,
      formatMessage({
        id: 'CREATEFORM_CHECKORDER_FIELD_MAX_CHARS_3',
        defaultMessage: 'Check Order should be less than 3 chars',
      }),
    );
}

function formUiSchema(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_FORMUISCHEMA_FIELD_IS_REQUIRED',
      defaultMessage: 'Form Ui Schema is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      formName: formName(formatMessage),
      checkOrder: checkOrder(formatMessage),
      formUiSchema: formUiSchema(formatMessage),
    })
    .required();

export default validationSchema;
